<template>
  <div>

        <span style="display: none">
当前日期-{{getCustomDate}}
        <button @click="monthOffset(0)">prev</button>
        <button @click="monthOffset(1)">next</button>
        <button @click="prevWeek">prev week</button>
        <button @click="nextWeek">next week</button>
        </span>
    <div class="calendar">
      <div class="week row">
        <div v-for="item in weekArr" class="col weekItem">{{item}}
          <ul>
            <li>上午</li>
            <li>下午</li>
            <li>晚上</li>
          </ul>
        </div>
      </div>
      <div class="rows">
        <div v-for="rowData in calendarData" class="row">
          <div v-for="colData in rowData" class="col"
               :class="{'today':colData.y===todayDate[0]&&colData.m===todayDate[1]&&colData.d===todayDate[2]}">
            {{(colData.m+1)+'月'+colData.d+'日'}}
            <ul>
              <li @click="orderAction(colData,step,$event)" v-for="step in colData.stepArr" class="timeunit"
                  :class="{'no':!step.status,'full':step.status===1,'can':step.status===2,'half':step.status===3,'ordered':step.status===4}"
                  :step="step.id" @mouseenter="mouseenter(colData,step)" @mousemove="mousemove(colData,step,$event)"
                  @mouseleave="mouseleave">
                <i v-if="step.status===4" class="iconfont icon-yuyue"></i>

              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>




  function padLeftZero(str) {
    str+="";
    return ('00' + str).substr(str.length);
  }


   export default {
    name: "calendar1",
    data() {
      return {
        /***
         * calendarMode
         * 0 月历
         * 1 周历
         */
        calendarMode: 0,
        //每个月天数数组
        daysPerMonth: [31, 28 + this.isLeapYear(this.showMonth), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
        //星期数组
        weekArr: ["日", "一", "二", "三", "四", "五", "六"],
        //日期数组（月份从0开始）
        currentDate: [],
        //日期时间段
        dateStepArr() {
          return [
            {
              id: 1,
              desc: "上午",
              ordered:0,
              status: 0,
              freeCount: 0,
              holdCount: 0,
            },
            {
              id: 2,
              desc: "下午",
              ordered:0,
              status: 0,
              freeCount: 0,
              holdCount: 0,
            },
            {
              id: 3,
              desc: "晚上",
              ordered:0,
              status: 0,
              freeCount: 0,
              holdCount: 0,
            },
          ]
        },

        //周日历偏移量
        weekCalendarOffsetCount: 0,
        //周日历偏移方式 0 向前 1 向后
        weekCalendarOffsetWay: null,
        //今天（周日历基准值）
        todayDate: [],
        //日历数据
        calendarData: [[]]
      }
    },
    watch: {
      currentDate(nv, ov) {
        console.log(`currentDate值发生变化:${ov}=>${nv}`);
        this.$emit("calendarChange", this.calendarData);

      }
    },
    methods: {
      isLeapYear: function (year) {
        return year % 100 == 0 ? (year % 400 == 0 ? 1 : 0) : (year % 4 == 0 ? 1 : 0);
      },
      //创建月历
      createMonthCalendarByDateObj() {
        //获取到当月第一天是周几
        let y = this.currentDate[0];
        let m = this.currentDate[1];
        let firstDayWeek = new Date(y, m, 1).getDay();
        //判断需要几行
        let rowsCount = Math.ceil((firstDayWeek + this.daysPerMonth[m]) / 7);
        //创建主数据
        let calendarData = [];
        for (let rowNu = 0; rowNu < rowsCount; rowNu++) {
          let rowData = []
          for (let colNu = 0; colNu < 7; colNu++) {
            let showDateDay = rowNu * 7 + colNu - firstDayWeek + 1;
            let showDateObj = {
              y: y,
              m: m,
              d: showDateDay,
              arr: [y, m, showDateDay],
              cusArr: [y, padLeftZero(m + 1), padLeftZero(showDateDay)],
              stepArr: this.dateStepArr()
            };
            if (showDateDay <= 0 || showDateDay > this.daysPerMonth[m]) {
              let showDate = new Date(y, m, showDateDay);
              showDateObj = this.getCalendarUnitByDateObj(showDate);
            }
            rowData.push(showDateObj)
          }
          calendarData.push(rowData)
        }
        this.calendarData=calendarData;
        return calendarData;
      },
      setCurrDateByDateObj(dateObj) {
        this.currentDate = [];
        let y = dateObj.getFullYear();
        let m = dateObj.getMonth();
        let d = dateObj.getDate();
        this.currentDate = [y, m, d];
      },
      getCalendarUnitByDateObj(dateObj) {
        return {
          y: dateObj.getFullYear(),
          m: dateObj.getMonth(),
          d: dateObj.getDate(),
          arr: [dateObj.getFullYear(), dateObj.getMonth(), dateObj.getDate()],
          cusArr: [dateObj.getFullYear(), padLeftZero(dateObj.getMonth() + 1), padLeftZero(dateObj.getDate())],
          stepArr: this.dateStepArr()
        }
      },
      monthOffset(way) {
        let offsetVal = 0;
        if (way) {
          offsetVal = 1;
        } else {
          offsetVal = -1
        }
        let curr = this.currentDate;
        let newDate = new Date(curr[0], curr[1] + offsetVal, 1);
        this.setCurrDateByDateObj(newDate);
        this.createMonthCalendarByDateObj();
        this.getBorderDate();
      },
      toToday() {
        this.currentDate = this.todayDate;
        this.createMonthCalendarByDateObj();
        this.getBorderDate();
      },
      //初始化今天日期对象
      initTodayDateObj() {
        let dateObj = new Date();
        this.todayDate = [dateObj.getFullYear(), dateObj.getMonth(), dateObj.getDate()];
        this.setCurrDateByDateObj(dateObj)
      },
      //=========以下方法为周日历相关============
      //通过某一天获取当前周
      getWeekArrByOneDate(dateObj) {
        let y = dateObj.getFullYear();
        let m = dateObj.getMonth();
        let d = dateObj.getDate();
        this.currentDate = [y, m, d];
        let week = dateObj.getDay();
        let surplus = 7 - week;
        let weekArr = [];
        for (let i = d - week; i < d + surplus; i++) {
          weekArr.push(this.getCalendarUnitByDateObj(new Date(y, m, i)))
        }
        return weekArr;
      },
      /**
       * 获取前n周或者后n周的数据
       * @param dateObj 基准日期对象
       * @param multiple 偏移周数
       */
      getWeekByOffsetMultiple(dateObj, multiple) {
        let y = dateObj.getFullYear();
        let m = dateObj.getMonth();
        let d = dateObj.getDate();
        let newDate = new Date(y, m, d + multiple * 7);
        return this.getWeekArrByOneDate(newDate)
      },
      /***
       * 智能获取两周数据
       * 通过weekCalendarOffsetCount和weekCalendarOffsetWay计算周数据
       */
      getWeekSmart() {
        if (this.weekCalendarOffsetWay) {

        }
      },
      prevWeek() {
      },
      nextWeek() {
      },

      /***
       * 事件处理
       */
      mouseenter(colData, step) {
        this.$emit("mouseenter", {date: colData, step: step});
      },
      mousemove(colData, step, ev) {
        this.$emit("mousemove", {date: colData, step: step, event: ev});
      },
      mouseleave() {
        this.$emit("mouseleave", {});
      },
      orderAction(date, step, ev) {
        this.$emit("orderAction", {date: date, step: step, event: ev});
      },
      //获取边界日期
      getBorderDate() {
        let headDate=this.calendarData[0][0];
        headDate=headDate.y+"-"+padLeftZero(headDate.m+1)+"-"+padLeftZero(headDate.d);
        let rowCount=this.calendarData.length;
        let data={headDate,dateCount:rowCount*7};
        this.$emit("borderDateOffset",data);
        return data;
      },
    },
    computed: {
      getCustomDate() {
        let customDate = [this.currentDate[0], this.currentDate[1] + 1, this.currentDate[2]];
        return customDate;
      }
    },
    mounted() {
      this.initTodayDateObj();
      this.createMonthCalendarByDateObj();
      this.getBorderDate();
    },
    filters: {},
    components: {}
  }
</script>

<style lang="stylus" scoped>
  @import "~common/stylus/config.styl"
  *
    box-sizing border-box

  .calendar
    .row
      width 100%

      .col
        width 14.2%
        /*height 100px*/
        line-height 100px
        float left
        border 1px solid #ccc
        font-size 12px

</style>



// WEBPACK FOOTER //
// src/components/order/orderCalendar.vue